import styled from 'styled-components';

import { IconButton } from 'src/components/IconButton';

export const CounterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

export const StyledIconButton = styled(IconButton)<{ isDisabled?: boolean }>`
  ${({ isDisabled }) => isDisabled && 'opacity: 0.2 !important;'};
  padding: 0;
  height: auto;

  svg {
    width: 2.4rem;
    height: 2.4rem;
    fill: ${({ theme: { colors } }) => colors.b2cRedThl};
  }
`;

export const StyledInput = styled.input`
  display: flex;
  font-size: 1.5rem;
  width: 2.4rem;
  padding: 0.8rem;
  align-item: flex-start;
  text-align: center;
  cursor: default;

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;
